module.exports = __webpack_public_path__ + "odstraneni-tetovaze_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/odstraneni-tetovaze_2_after.jpg
// module id = 955
// module chunks = 0